module.exports = __webpack_public_path__ + "img/icon-user.0666f00b.svg";